export default __webpack_public_path__ + "static/media/Logo.7ca32385.jpg";